import { render, staticRenderFns } from "./ThankyouDialog.vue?vue&type=template&id=4a143d75"
import script from "./ThankyouDialog.vue?vue&type=script&lang=js"
export * from "./ThankyouDialog.vue?vue&type=script&lang=js"
import style0 from "./ThankyouDialog.vue?vue&type=style&index=0&id=4a143d75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports